import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navClasses = isHomePage
    ? `fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`
    : 'fixed top-0 left-0 right-0 z-50 bg-white shadow-sm';

  const textColor = isHomePage && !isScrolled ? 'text-white' : 'text-black';
  const logoSrc = 'https://static.readdy.ai/image/c547be34c1bf7bb39243860cf03ecf7c/44a2401a64e2a2728e9bc538c6daa347.png';

  return (
    <nav className={navClasses}>
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-20 py-4 md:py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center cursor-pointer">
          <img src={logoSrc} alt="UKPropertiez" className="h-10 md:h-[52.8px]" />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-8 xl:gap-12">
          <Link
            to="/"
            className={`text-base font-normal ${textColor} hover:text-[#00b2f6] transition-colors cursor-pointer`}
          >
            Home
          </Link>
          <Link
            to="/about"
            className={`text-base font-normal ${textColor} hover:text-[#00b2f6] transition-colors cursor-pointer`}
          >
            About Us
          </Link>
          <Link
            to="/services"
            className={`text-base font-normal ${textColor} hover:text-[#00b2f6] transition-colors cursor-pointer`}
          >
            Services
          </Link>
          <Link
            to="/approach"
            className={`text-base font-normal ${textColor} hover:text-[#00b2f6] transition-colors cursor-pointer`}
          >
            Our Approach
          </Link>
          <Link
            to="/partners"
            className={`text-base font-normal ${textColor} hover:text-[#00b2f6] transition-colors cursor-pointer`}
          >
            Who We Work With
          </Link>
        </div>

        <Link
          to="/contact"
          className="hidden lg:block px-6 xl:px-8 py-3 bg-[#00b2f6] text-white rounded-full text-base font-medium hover:bg-[#0099d6] transition-colors whitespace-nowrap cursor-pointer"
        >
          Contact Us
        </Link>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${textColor}`}
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-5 py-6 space-y-4">
            <Link
              to="/"
              className="block text-base font-normal text-black hover:text-[#00b2f6] transition-colors cursor-pointer py-2"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block text-base font-normal text-black hover:text-[#00b2f6] transition-colors cursor-pointer py-2"
            >
              About Us
            </Link>
            <Link
              to="/services"
              className="block text-base font-normal text-black hover:text-[#00b2f6] transition-colors cursor-pointer py-2"
            >
              Services
            </Link>
            <Link
              to="/approach"
              className="block text-base font-normal text-black hover:text-[#00b2f6] transition-colors cursor-pointer py-2"
            >
              Our Approach
            </Link>
            <Link
              to="/partners"
              className="block text-base font-normal text-black hover:text-[#00b2f6] transition-colors cursor-pointer py-2"
            >
              Who We Work With
            </Link>
            <Link
              to="/contact"
              className="block w-full px-6 py-3 bg-[#00b2f6] text-white rounded-full text-base font-medium hover:bg-[#0099d6] transition-colors whitespace-nowrap cursor-pointer text-center mt-4"
            >
              Contact Us
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
